import { showMessage, hideMessage } from './store/message-actions';
import { message } from './store/message-reducer';
import { NAME } from './store/message-state-name';

export { createMessageMiddleware } from './store/message-middleware';

export const messageActions = {
  showMessage,
  hideMessage,
};

export const messageReducer = { [NAME]: message };
